import { initM43Analytics, installGlobalM43 } from './analytics-core'

installGlobalM43()
initM43Analytics()
